import React, { type FC, type PropsWithChildren } from 'react';

import styled from '@emotion/styled';

export interface SpacerProps {
  /** Allows the component to get additional styles. */
  className?: string;
}

const StyledSpacer = styled.div<SpacerProps>({
  label: 'spacer',
  width: '100%',
});

const Spacer: FC<PropsWithChildren<SpacerProps>> = ({ className, ...rest }) => (
  <StyledSpacer {...rest} className={className} />
);

export { Spacer };
export default Spacer;
